// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
import { z } from 'zod';
const createGuard = z.object({
    tenantId: z.string().max(21).optional(),
    organizationId: z.string().min(1).max(21),
    userId: z.string().min(1).max(128),
    status: z.string().min(1).max(16).optional(),
});
const guard = z.object({
    tenantId: z.string().max(21),
    organizationId: z.string().min(1).max(21),
    userId: z.string().min(1).max(128),
    status: z.string().max(16),
});
export const OrganizationDirectoryMemberships = Object.freeze({
    table: 'organization_directory_memberships',
    tableSingular: 'organization_directory_membership',
    fields: {
        tenantId: 'tenant_id',
        organizationId: 'organization_id',
        userId: 'user_id',
        status: 'status',
    },
    fieldKeys: [
        'tenantId',
        'organizationId',
        'userId',
        'status',
    ],
    createGuard,
    guard,
    updateGuard: guard.partial(),
});
